<template>
  <TableLayout :permissions="['business:creation:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" >
      <el-form-item label="用户" prop="nickname">
        <el-input v-model="searchForm.nickname" placeholder="请输入昵称/手机号/姓名" @keypress.enter.native="search"></el-input>
      </el-form-item>

      <el-form-item label="状态" prop="status">
        <el-select
          v-model="searchForm.status"
          placeholder="请选择状态"
          clearable
        >
          <el-option :key="0" :value="0" label="正常"></el-option>
          <el-option :key="1" :value="1" label="禁用"></el-option>
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:creation:create', 'business:creation:delete']">
        <li><el-button type="primary" @click="$refs.operaCreationWindow.open('新建创作者')" icon="el-icon-plus" v-permissions="['business:creation:create']">新建创作者</el-button></li>
        <li><el-button type="danger"  @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:creation:delete']">删除创作者</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <el-table-column prop="login" label="登录账号" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="realname" label="真实姓名" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="idcard" label="身份证号" align="center" min-width="100px"></el-table-column>
        <el-table-column label="用户" align="center" min-width="100px">
          <template slot-scope="{row}">
            <!-- {{ row.imgFullUrl+row.imgurl }} -->
            <div style="display: flex; line-height: 60px;">

              <el-image style="width: 60px; height: 60px; border-radius: 50%;margin-right: 10px;" :scr="row.imgFullUrl+row.imgurl" :preview-src-list="[row.imgurlfull]"></el-image>
              {{ row.nickname }}
            </div>
            <!-- <el-image style="width: 60px; height: 60px; border-radius: 50%;" :src="row.imgurl"></el-image>
            {{ row.nickname }} -->
          </template>
        </el-table-column>
        <el-table-column prop="memberId" label="关联用户" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" align="center" min-width="100px"></el-table-column>
        <el-table-column label="状态" fixed="right" align="center" min-width="100px">
          <template slot-scope="{row}">
            <el-switch
              v-model="row.status"
              active-color="#13ce66"
              inactive-color="#999"
              :active-value="0"
              :inactive-value="1"
              @change="statusChange(row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="120"
          fixed="right"
          align="center"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaCreationWindow.open('编辑创作者', row)" v-permissions="['business:creation:update']">编辑</el-button>
            <el-button type="text" style="color: red;"  @click="deleteById(row)" v-permissions="['business:creation:delete']">删除</el-button>
            <el-button type="text" @click="$refs.operaCreationApplyDetail.open('创作者详情', row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaCreationWindow ref="operaCreationWindow" @success="handlePageChange"/>
    <OperaCreationApplyDetail ref="operaCreationApplyDetail" />
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaCreationWindow from '@/components/business/OperaCreationWindow'
import OperaCreationApplyDetail from '@/components/business/OperaCreationApplyDetail'
import { updateStatusById } from '@/api/business/creation'
export default {
  name: 'Creation',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaCreationWindow, OperaCreationApplyDetail },
  data () {
    return {
      // 搜索
      searchForm: {
        nickname: '',
        status: ''
      }
    }
  },
  created () {
    this.config({
      module: '创作中心信息表',
      api: '/business/creation',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    statusChange(row) {
      updateStatusById(row)
        .then(() => {
          this.$tip.success('修改成功')
        })
        .catch(e => {
          this.$tip.error(e)
        })
        .finally(() => {
          this.handlePageChange()
        })
    },
    showDetail(row) {

    }
  },
}
</script>
